module.exports = __webpack_public_path__ + "KingPinLogo.856d008d.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/HomePage/KingPinLogo.png
// module id = 617
// module chunks = 0